export default {
  name: "SearchDropdown",
  components: {},
  data() {
    return {
      toplist: true,
      artist: false,
      song: false,
      data: false,
      searchQuery: ""
    };
  },
  methods: {
    search: function() {
        if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            if(this.searchQuery.length > 0){
            if (this.unchecked() && !this.$route.name.includes("wyszukaj")) {
              this.$router.push({ path: "/wyszukaj" });
            }
            if (this.unchecked())
              this.$store.dispatch("setSearchQuery", this.searchQuery);
            if (this.toplist) {
              this.$store.dispatch("setSearchCategory", "List/Search");
            } else if (this.artist) {
              this.$store.dispatch("setSearchCategory", "Artist/Search");
            } else if (this.song) {
              this.$store.dispatch("setSearchCategory", "Song/Search");
            } else if (this.data) {
              this.$store.dispatch("setSearchCategory", "List/SearchByYear");
            }
          }
        }, 800);
      
    },
    unchecked() {
      return this.toplist || this.artist || this.song || this.data;
    },
    reSearch() {
      if (this.searchQuery.length !== 0) return this.search();
    },
    toplistChange: function() {
      this.artist = false;
      this.song = false;
      this.data = false;
      this.reSearch();
    },
    artistChange: function() {
      this.toplist = false;
      this.song = false;
      this.data = false;
      this.reSearch();
    },
    songChange: function() {
      this.artist = false;
      this.toplist = false;
      this.data = false;
      this.reSearch();
    },
    dataChange: function() {
      this.artist = false;
      this.toplist = false;
      this.song = false;
      this.reSearch();
    }
  },

  mounted() {
    if (this.$route.name.includes("wyszukaj")) {
    switch (this.$store.state.searchCategory) {
      case "List/Search":
        this.artist = false;
        this.song = false;
        this.toplist = true;
        this.data = false;
        break;
      case "Song/Search":
        this.artist = false;
        this.song = true;
        this.toplist = false;
        this.data = false;
        break;
      case "List/SearchByYear":
        this.artist = false;
        this.song = false;
        this.toplist = false;
        this.data = true;
        break;
      case "Artist/Search":
        this.artist = true;
        this.song = false;
        this.toplist = false;
        this.data = false;
        break;
    }
    if (this.$store.state.searchQuery.length > 0) this.searchQuery =  this.$store.state.searchQuery;
  }
},
  computed: {
    searchActive() {
      return this.$store.state.searchActive;
    }
  },
};
